import axios from '../configs/axios';

class SourceRepository {
    async getSourceById(sourceId) {
        return await axios.get(`source/${sourceId}`);
    }
    async updateSourceById(sourceId, payload){
        const response = await axios.put(`source/${sourceId}`, payload);
        return response;
    }
}

export default new SourceRepository();
